import $ from "jquery";
import cookie from "js-cookie";
import Marionette from "backbone.marionette";

import { ACCOUNT_TYPE } from "lib/constants";

import events from "../events";
import component from "../components";
import util from "../util";

export default Marionette.View.extend({
    template: false,
    ui: {
        regBtn: ".btn-primary",
    },
    events: {
        "click @ui.regBtn": "onSubmit",
    },
    serializeData() {
        return {};
    },
    onRender() {
        if (window.authUser) {
            return;
        }

        this.eventType = this.$el.data("etype") || "UNKNOWN";
        this.accountType = Number(this.$el.data("atype") || ACCOUNT_TYPE.APPLICANT);

        if (util.shouldShowLogin()) {
            this.view = new component.LoginView({
                el: "#program-sign-up",
            });
        } else {
            this.view = new component.SignupView({
                el: "#program-sign-up",
                accountType: this.accountType,
                showPhone: false,
            });
        }
        this.view.render();
    },
    onSubmit(e) {
        e.preventDefault();
        this.ui.regBtn.loading(true);

        if (!this.view) {
            // User's logged in
            this.register();
            return;
        }

        if (util.shouldShowLogin()) {
            const promise = this.view.login();
            if (promise) {
                promise
                    .done(() => {
                        this.register();
                    })
                    .fail(() => {
                        events.track(this.eventType, "login_failed");
                        this.ui.regBtn.loading(false);
                    });
            } else {
                this.ui.regBtn.loading(false);
            }
            return;
        }

        const promise = this.view.submit();
        if (promise) {
            promise
                .done(() => {
                    setTimeout(() => {
                        this.register();
                    }, 0);
                })
                .fail(() => {
                    this.ui.regBtn.loading(false);
                });
        } else {
            this.ui.regBtn.loading(false);
        }
    },
    register() {
        const $form = $("#program-register-form");

        const utm = cookie.get("utm");
        if (utm && utm.length > 0) {
            $form.find("input").val(utm);
        }

        $form.submit();
    },
});
